<template>
    <div class="view-overview">
        this is overview
    </div>
</template>


<script>
export default {
    data() {
        return {

        }
    }
}
</script>